import { api } from "@services/baseURL";

export const SaveCompliance = async (data) => {
  try {
    const response = await api.post('Compliance', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar compliance:', error);
    throw error;
  }
};

export const UpdateCompliance = async (id, data) => {
  try {
    const response = await api.patch(`Compliance/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar compliance:', error.response?.data || error.message);
    throw error;
  }
};

export const DeleteCompliance = async (id) => {
  try {
    await api.delete(`Compliance/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar compliance:', error);
    throw error;
  }
};

export const GetAllCompliances = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('Compliance', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos compliances:', error);
    throw error;
  }
};

export const GetByIdCompliance = async (id) => {
  try {
    const response = await api.get(`Compliance/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar compliance:', error);
    throw error;
  }
};

export default {
  SaveCompliance,
  UpdateCompliance,
  DeleteCompliance,
  GetByIdCompliance,
  GetAllCompliances
};